// store/slices/ordersSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { REACT_APP_API } from "../consts/consts";

// 🔥 NUEVO
export const fetchOrderById = createAsyncThunk(
  "orders/fetchById",
  async (orderId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${REACT_APP_API}orders/${orderId}`);
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error al obtener el pedido"
      );
    }
  }
);


/* ================= THUNK ================= */

export const createOrder = createAsyncThunk(
  "order/create",
  async (orderData, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}orders/add`,
        orderData
      );
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error al crear la orden"
      );
    }
  }
);

/* ================= SLICE ================= */

const initialState = {
  currentOrder: null,
  checkoutCustomer: null,
  loading: false,
  error: null,
  /* Board data: the admin dashboard reads the order list from here. */
  allOrders: [],
  allOrdersLoading: false,
  /* Detail pages (OrderAdmin/Process/Finish) index [0] on this value. */
  orderAdmin: [],
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setCheckoutCustomer(state, action) {
      state.checkoutCustomer = action.payload;
    },
    clearOrder(state) {
      state.currentOrder = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.currentOrder = action.payload;
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 🔥 FETCH ORDER BY ID
      .addCase(fetchOrderById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrderById.fulfilled, (state, action) => {
        state.loading = false;
        // 🔥 Normalizamos: si viene array, tomamos el primero
        state.currentOrder = Array.isArray(action.payload)
          ? action.payload[0]
          : action.payload;
      })
      .addCase(fetchOrderById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      /* Board actions come from store/actions/orders.js, which dispatches
         plain action objects instead of thunks. */
      .addCase("GET_ALL_ORDERS_REQUEST", (state) => {
        state.allOrdersLoading = true;
      })
      .addCase("GET_ALL_ORDERS", (state, action) => {
        state.allOrdersLoading = false;
        state.allOrders = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase("GET_ALL_ORDERS_FAIL", (state) => {
        state.allOrdersLoading = false;
      })
      .addCase("PREP_ORDER_ADMIN", (state, action) => {
        const { id, status } = action.payload || {};

        if (id === undefined || id === null) return;

        state.allOrders = state.allOrders.map((order) =>
          String(order.id) === String(id) ? { ...order, status } : order
        );
      })
      /* The detail pages index the first position, so this is always a list. */
      .addCase("GET_ORDER_ADMIN", (state, action) => {
        const payload = action.payload;

        if (Array.isArray(payload)) {
          state.orderAdmin = payload;
        } else {
          state.orderAdmin = payload ? [payload] : [];
        }
      });
  },
});

export const { setCheckoutCustomer, clearOrder } = orderSlice.actions;
export default orderSlice.reducer;
